export default __webpack_public_path__ + "static/media/document_active.bb0b5991.svg";